import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AllCounselor from "./AllCounselor";

const AllCounselorLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb mainHeading="Counselor" title="All Counselors" />
      <AllCounselor url={"counselors/all"} />
    </MasterLayout>
  );
};

export default AllCounselorLayout;
